module.exports = __webpack_public_path__ + "img/knue_gallery12.5dda7198.jpg";